import React, { useMemo } from 'react';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { Bar, Doughnut } from 'react-chartjs-2';
import { BRAND } from '../../theme/brandTheme';
import { formatNumber } from '../../utils/statisticsUtils';
import { baseChartOptions, CHART_COLORS } from './chartSetup';

/** Pre-test planning visualizations — sample size & duration */
const PreTestResultsCharts = ({ preTestResults }) => {
  const sampleBarData = useMemo(() => {
    if (!preTestResults) return null;
    const perVariant = preTestResults.sampleSizePerVariant;
    return {
      labels: ['Varyant A', 'Varyant B'],
      datasets: [
        {
          label: 'Gerekli Örneklem',
          data: [perVariant, perVariant],
          backgroundColor: [`${CHART_COLORS.control}CC`, `${BRAND.green}CC`],
          borderColor: [CHART_COLORS.control, BRAND.green],
          borderWidth: 1,
          borderRadius: 6,
        },
      ],
    };
  }, [preTestResults]);

  const durationDoughnutData = useMemo(() => {
    if (!preTestResults?.duration) return null;
    const days = preTestResults.duration.durationDays || 0;
    const weeks = preTestResults.duration.durationWeeks || 0;
    return {
      labels: ['Gün', 'Hafta (yaklaşık)'],
      datasets: [
        {
          data: [days, weeks * 7],
          backgroundColor: [BRAND.purple, `${BRAND.green}99`],
          borderWidth: 0,
        },
      ],
    };
  }, [preTestResults]);

  if (!preTestResults) return null;

  const barOptions = {
    ...baseChartOptions,
    plugins: { ...baseChartOptions.plugins, legend: { display: false } },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { font: { family: BRAND.fontFamily } },
        grid: { color: 'rgba(0,0,0,0.06)' },
      },
      x: { ticks: { font: { family: BRAND.fontFamily } }, grid: { display: false } },
    },
  };

  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: 700, color: BRAND.purple, mb: 2, fontFamily: BRAND.fontFamily }}>
          Planlama Özeti
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5, color: BRAND.textGray }}>
              Varyant Başına Örneklem
            </Typography>
            <Box sx={{ height: 220 }}>
              <Bar data={sampleBarData} options={barOptions} />
            </Box>
            <Typography variant="caption" sx={{ color: BRAND.textMuted, display: 'block', mt: 1 }}>
              Toplam: {formatNumber(preTestResults.sampleSize)} ziyaretçi
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5, color: BRAND.textGray }}>
              Tahmini Test Süresi
            </Typography>
            <Box sx={{ height: 220, display: 'flex', justifyContent: 'center' }}>
              <Doughnut
                data={durationDoughnutData}
                options={{
                  ...baseChartOptions,
                  plugins: {
                    ...baseChartOptions.plugins,
                    legend: { position: 'bottom' },
                    tooltip: {
                      callbacks: {
                        label: (ctx) => {
                          if (ctx.dataIndex === 0) return `${preTestResults.duration.durationDays} gün`;
                          return `${preTestResults.duration.durationWeeks} hafta`;
                        },
                      },
                    },
                  },
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default PreTestResultsCharts;
